import React, { useState } from "react"

import useOnclickOutside from "react-cool-onclickoutside"

import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { MenuItemElement } from "../../../elements/menuItem.element.tsx"
import type { IMenuItem } from "../../../types/objects.types.ts"
import type { IMenuProps } from "../../../types/props.types.ts"

import closeIcon from "@front-shared/assets/images/icons/close-dark.svg"
import hamburgerIcon from "@front-shared/assets/images/icons/hamburger-dark2.svg"

export const MobileMenuComponent: React.FunctionComponent<
    IMenuProps
> = props => {
    const onCloseMenu = () => {
        setIsMenuActive(false)
    }

    const containerRef = useOnclickOutside(onCloseMenu)

    const onActivateMenu = () => {
        setIsMenuActive(true)
    }

    const [isMenuActive, setIsMenuActive] = useState<boolean>(false)

    return (
        <div className={`items-center hidden md:flex ${props.className}`}>
            <div className="flex-1" />

            <div
                className="py-[8px] px-[16px] cursor-pointer"
                onClick={onActivateMenu}
            >
                <img src={hamburgerIcon} alt="menu" />
            </div>

            {isMenuActive && (
                <div
                    ref={containerRef}
                    className={`
                        fixed h-screen z-30 bg-brand-white p-[24px] shadow-7 overflow-hidden overflow-y-auto
                        w-[365px] sm:w-screen top-0 right-0
                    `}
                >
                    <div className="flex">
                        <div className="flex-1" />

                        <div
                            className="cursor-pointer px-[16px] pb-[4px]"
                            onClick={onCloseMenu}
                        >
                            <img src={closeIcon} alt="close" />
                        </div>
                    </div>

                    <div>
                        {props.menuItems.map(
                            (item: IMenuItem, index: number) => {
                                const hasSubmenu = !!item.submenu
                                const hasSubmenuItems =
                                    (item.submenu?.length ?? 0) > 0

                                return hasSubmenu ? (
                                    hasSubmenuItems ? (
                                        <div key={index}>
                                            <PrimaryText
                                                typography="subtitle"
                                                className="mt-[20px]"
                                            >
                                                {item.label}
                                            </PrimaryText>

                                            {item.submenu?.map(
                                                (subItem: IMenuItem) => {
                                                    return (
                                                        <MenuItemElement
                                                            key={subItem.label}
                                                            item={subItem}
                                                            onClick={
                                                                onCloseMenu
                                                            }
                                                            className="ml-[32px] mt-[20px]"
                                                            typography="subtitle"
                                                            activeTypography="subtitleSemibold"
                                                        />
                                                    )
                                                },
                                            )}
                                        </div>
                                    ) : null
                                ) : (
                                    <MenuItemElement
                                        key={index}
                                        item={item}
                                        onClick={onCloseMenu}
                                        className="mt-[20px]"
                                        typography="subtitle"
                                        activeTypography="subtitleSemibold"
                                    />
                                )
                            },
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}
